import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const MobileQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <div
        onClick={() => window.open("https://open.kakao.com/o/sFNr9vch")}
        className="fixed right-0 bottom-14  w-fit h-fit z-40 md:hidden"
      >
        <img src="/images/iconKakao.png" alt="icon" width={60} height={60} />
      </div>
      <div className="fixed right-0 bottom-0 w-full h-fit z-40 md:hidden">
        <div className="grid grid-cols-2 lg:block">
          <div
            onClick={() => {
              window.location.href = "tel:010-9287-9477";
            }}
            className=" relative w-full h-full cursor-pointer border border-white border-b-0"
          >
            <img
              className="!relative w-full h-full object-cover"
              src="images/quick5.png"
              alt="quick"
              width={260}
              height={95}
            />
          </div>
          <div
            onClick={openfunc}
            className=" relative w-full h-full cursor-pointer border border-white border-b-0"
          >
            <img
              className="!relative w-full h-full object-cover"
              src="images/quick6.png"
              alt="quick"
              width={260}
              height={95}
            />
          </div>
        </div>
        {/* <div className="grid grid-cols-3 lg:block">
                <div
                    onClick={() => {
                        window.open('/');
                    }}
                    className=" relative w-full h-full bg-[#30b14a] cursor-pointer border border-white"
                >
                    <img
                        className="!relative w-full h-full object-cover"
                        src="images/quick2.png"
                        alt="quick"
                        width={260}
                        height={95}
                    />
                </div>
                <div
                    onClick={() => {
                        window.open('/');
                    }}
                    className=" relative w-full h-full bg-[#ffe600] cursor-pointer border border-white"
                >
                    <img
                        className="!relative w-full h-full object-cover"
                        src="images/quick3.png"
                        alt="quick"
                        width={260}
                        height={95}
                    />
                </div>
                <div
                    onClick={() => {
                        window.open('/');
                    }}
                    className=" relative w-full h-full bg-[#00db39] cursor-pointer border border-white"
                >
                    <img
                        className="!relative w-full h-full object-cover"
                        src="images/quick4.png"
                        alt="quick"
                        width={260}
                        height={95}
                    />
                </div>
            </div> */}
        <ModalPop popupRef={popupRef} closefnc={closefunc} />
      </div>
    </>
  );
};

export default MobileQuick;
